import { forwardRef, useContext } from 'react';
import { cn } from 'Utils/cn';
import PropTypes from 'prop-types';
import OutlineChevronDown from 'Components/Atoms/OutlineIcons/OutlineChevronDown';
import selectVariants from 'Components/Atoms/Select/SelectVariants';
import ButtonClear from 'Components/Atoms/ButtonClear/ButtonClear';
import DropdownContext from 'Components/Atoms/Dropdown/DropdownContext';

const MultiselectTrigger = forwardRef(function MultiselectTrigger(props, ref) {
    const {
        size,
        className,
        label,
        disabled = false,
        enableClear = false,
        onClear,
        icon,
        status,
        isOpen,
        hasSelected,
    } = props;

    const { refs, getReferenceProps } = useContext(DropdownContext);

    return (
        <button
            ref={(node) => {
                refs.setReference(node);
                if (typeof ref === 'function') {
                    ref(node);
                } else if (ref) {
                    ref.current = node;
                }
            }}
            type="button"
            disabled={disabled}
            className={cn(
                selectVariants({ size, status, className }),
                'gap-1',
                isOpen && 'border-primary ring-2 ring-primary/20',
                !hasSelected && 'text-dark-blue/50',
            )}
            aria-haspopup="listbox"
            aria-expanded={isOpen}
            {...getReferenceProps()}
        >
            {icon && <span className="shrink-0 mr-1">{icon}</span>}
            <div className="truncate grow min-w-0">{label}</div>
            {enableClear && !disabled && <ButtonClear onClear={onClear} />}
            <OutlineChevronDown size={20} className="shrink-0 text-dark-blue" color="currentColor" />
        </button>
    );
});

export default MultiselectTrigger;

MultiselectTrigger.propTypes = {
    className: PropTypes.string,
    size: PropTypes.oneOf(['normal', 'small']),
    disabled: PropTypes.bool,
    enableClear: PropTypes.bool,
    onClear: PropTypes.func,
    icon: PropTypes.node,
    label: PropTypes.node,
    context: PropTypes.object,
    status: PropTypes.string,
    isOpen: PropTypes.bool,
    hasSelected: PropTypes.bool,
};
